<template>
    <button class="btn-action btn-action--primary" @click="synchronize()">
        <font-awesome-icon icon="fa-solid fa-arrows-rotate" />&nbsp;
        <strong>{{ text }}</strong>
    </button>
</template>

<script>
import EmployeesApi from '../repository/api/EmployeesApi';
export default {
    name: "SyncButton",
    props: {
        all: {
            type: Boolean,
            default: false,
        },
        checked: {
            type: Array,
            default: () => [],
        },
        text: {
            type: String,
            default: "Sinkronisasi Data Pegawai",
        },
    },
    methods: {
        async synchronize() {
            this.$swal({
                    icon: "success",
                    title: "Proses Sinkronisasi",
                    text: "Saat ini data pegawai sedang dalam proses sinkronisasi",
                    confirmButtonText: "Lihat Data"
                })
                if (this.all === false && this.checked.length === 0) {
                    this.$swal({
                        icon: "error",
                        title: "Pilih data terlebih dahulu"
                    })
                }
                else {
                    this.$swal({
                        html: "<div class='spinner-border' style='width: 88px;height: 88px;'></div><h2 class='swal2-title' id='swal2-title' style='display: block;'>Proses Sinkronisasi</h2><div class='swal2-html-container' id='swal2-html-container' style='display: block;'>Saat ini data pegawai sedang dalam proses sinkronisasi</div>",
                        showConfirmButton: false,
                    });
                    let data = new FormData();
                    this.checked.map((item) => {
                        data.append('nip', item)
                    });
                
                    await EmployeesApi.synchronize(data).then(() => {                        
                        this.$swal({
                            icon: "success",
                            title: "Proses Sinkronisasi Berhasil",
                            text: "Proses sinkronisasi berhasil silakan cek data",
                            confirmButtonText: "Lihat Data"
                        })
                    }).catch((error) => {
                        let text = '';

                        if (Object.keys(error?.response?.data?.errors || {}).length === 1) {
                            if (error?.response?.data?.errors?.jabatan !== undefined) {
                                text = `Sinkronisasi gagal, jabatan <strong>${error?.response?.data?.errors?.jabatan?.join(', ')}</strong> belum terdaftar pada sistem, silahkan input data jabatan pada fitur master jabatan`;

                            } else if (error?.response?.data?.errors?.unit_kerja !== undefined) {
                                text = `Sinkronisasi gagal, Unit kerja <strong>${error?.response?.data?.errors?.unit_kerja?.join(', ')}</strong> belum terdaftar pada sistem, silahkan input data unit kerja pada fitur master unit kerja`;

                            } else if (error?.response?.data?.errors?.lead_nip !== undefined) {
                                text = `Sinkronisasi gagal, data leader <strong>${error?.response?.data?.errors?.lead_nip?.join(', ')}</strong> belum terdaftar pada sistem, silahkan register data pegawai tersebut`;

                            } else if (error?.response?.data?.errors?.immediate_nip !== undefined) {
                                text = `Sinkronisasi gagal, data immediate leader <strong>${error?.response?.data?.errors?.immediate_nip?.join(', ')}</strong> belum terdaftar pada sistem, silahkan register data pegawai tersebut`;
                            }

                        } else if (Object.keys(error?.response?.data?.errors || {}).length > 1) {
                            text += `Sinkronisasi gagal,<br/>`;
                            if (error?.response?.data?.errors?.jabatan !== undefined) {
                                text += `jabatan <strong>${error?.response?.data?.errors?.jabatan?.join(', ')}</strong> belum terdaftar pada sistem,<br/>`;
                            } 
                            
                            if (error?.response?.data?.errors?.unit_kerja !== undefined) {
                                text += `Unit kerja <strong>${error?.response?.data?.errors?.unit_kerja?.join(', ')}</strong> belum terdaftar pada sistem,<br/>`;
                            } 
                            
                            if (error?.response?.data?.errors?.lead_nip !== undefined) {
                                text += `data leader <strong>${error?.response?.data?.errors?.lead_nip?.join(', ')}</strong> belum terdaftar pada sistem,<br/>`;
                            } 
                            
                            if (error?.response?.data?.errors?.immediate_nip !== undefined) {
                                text += `data immediate leader <strong>${error?.response?.data?.errors?.immediate_nip?.join(', ')}</strong> belum terdaftar pada sistem,<br/>`;
                            }
                            text += `silahkan input data tersebut.`;
                        }
    
                        this.$swal({
                            icon: "error",
                            title: error?.response?.data?.message ?? "Gagal Terhubung",
                            html: text,
                        });
                    });
                }

            this.$emit('check-sync-tasks');
        },
    },
}
</script>